/**
* Related Products Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Related Products Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import ScrollMagic from 'ScrollMagic';
// import animationGSAP from 'animation.gsap';
// import addIndicators from 'debug.addIndicators';
// import TweenMax from 'TweenMax';
// import TimelineMax from 'TimelineMax';
( function( app ) {
  const COMPONENT = {

    className: 'related-products-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.related-products-slider .products' ).slick( {
        dots: false,
        arrows: true,
        slidesToShow: 3,
        infinite: true,
        autoplay: false,
        prevArrow: '<button type="button" class="slick-prev"><svg class="icon icon-left-arrow"><use xlink:href="#icon-left-arrow"></use></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><svg class="icon icon-right-arrow"><use xlink:href="#icon-right-arrow"></use></svg></button>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'related-products-slider', COMPONENT );
} )( app );
